import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../hooks/useAuth';
import { FiX, FiUser, FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthContainer = styled.div<{ variant: 'modal' | 'widget' }>`
  display: flex;
  flex-direction: column;
  background: ${props => props.variant === 'modal' ? 'white' : 'linear-gradient(135deg, #FFFAE6 0%, #FFFBE9 100%)'};
  border-radius: ${props => props.variant === 'modal' ? '24px' : '18px'};
  width: ${props => props.variant === 'modal' ? '400px' : 'calc(100vw - 16px)'};
  max-width: ${props => props.variant === 'modal' ? '400px' : 'calc(100vw - 16px)'};
  height: auto; /* hamesha auto */
  max-height: 90vh; /* screen ke 90% se zyada na ho */
  box-shadow: ${props => props.variant === 'modal'
    ? '0 20px 60px 0 rgba(232, 155, 60, 0.25), 0 8px 24px 0 rgba(0,0,0,0.15)'
    : '0 4px 16px rgba(0,0,0,0.08)'};
  position: relative;
  overflow-y: hidden; /* scroll hatana */
  margin: ${props => props.variant === 'modal' ? '32px 0' : '8px'};
  padding: ${props => props.variant === 'modal' ? '0' : '24px 20px'};
  align-items: center;
  border: ${props => props.variant === 'modal' ? '2px solid #ffd700' : 'none'};
`;


const AuthHeader = styled.div<{ variant: 'modal' | 'widget' }>`
  background: ${props => props.variant === 'modal' 
    ? 'linear-gradient(135deg, #e89b3c 0%, #ff9900 100%)' 
    : 'transparent'};
  color: white;
  padding: ${props => props.variant === 'modal' ? '28px 28px 18px 28px' : '0'};
  border-top-left-radius: ${props => props.variant === 'modal' ? '24px' : '18px'};
  border-top-right-radius: ${props => props.variant === 'modal' ? '24px' : '18px'};
  font-size: ${props => props.variant === 'modal' ? '22px' : '16px'};
  font-weight: 700;
  text-align: left;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const HeaderText = styled.div` display: flex; flex-direction: column; `;
const HeaderSubtitle = styled.div` font-size: 14px; color: #fff; opacity: 0.9; margin-top: 2px; `;

const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
`;

const CloseButtonFloating = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  color: #e89b3c;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
`;

const AuthContent = styled.div<{ variant: 'modal' | 'widget' }>`
  flex: 1 1 auto;
  width: 100%;
  padding: ${props => props.variant === 'modal' ? '32px 28px' : '0 0 24px 0'};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const AuthTitle = styled.h2<{ variant: 'modal' | 'widget' }>`
  margin: 0 0 8px 0;
  color: #e89b3c;
  font-size: ${props => props.variant === 'modal' ? '28px' : '24px'};
  font-weight: 700;
  text-align: center;
`;

const AuthSubtitle = styled.p<{ variant: 'modal' | 'widget' }>`
  margin: 0 0 24px 0;
  color: #6b7280;
  font-size: ${props => props.variant === 'modal' ? '16px' : '14px'};
  text-align: center;
`;

const ModeToggle = styled.div`
  display: flex;
  background: white;
  border-radius: 12px;
  padding: 4px;
  margin-bottom: 24px;
  border: 2px solid #ffd700;
  width: 100%;
  max-width: 320px;
`;

const ModeButton = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background: ${props => props.active ? 'linear-gradient(135deg, #e89b3c 0%, #ff9900 100%)' : 'transparent'};
  color: ${props => props.active ? 'white' : '#6b7280'};
  font-weight: 600;
  cursor: pointer;
`;

const Form = styled.form`
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InputGroup = styled.div` position: relative; `;
const InputWrapper = styled.div` position: relative; display: flex; align-items: center; `;
const InputIcon = styled.div` position: absolute; left: 12px; color: #9ca3af; `;
const Input = styled.input`
  width: 100%;
  padding: 14px 14px 14px 40px;
  border: 2px solid #ffd700;
  border-radius: 12px;
`;

const PasswordToggle = styled.button`
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
`;

const Button = styled.button`
  width: 100%;
  padding: 14px 0;
  background: linear-gradient(135deg, #e89b3c 0%, #ff9900 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 700;
  font-size: 16px;
`;

const ErrorMessage = styled.div`
  background: #fef2f2;
  color: #dc2626;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
`;
const SuccessMessage = styled.div`
  background: #f0fdf4;
  color: #16a34a;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
`;

const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
  @keyframes spin { to { transform: rotate(360deg); } }
`;

const FeatureList = styled.div`
  margin-top: 20px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
`;
const FeatureItem = styled.div` font-size: 13px; color: #6b7280; &::before { content: '✓'; color: #e89b3c; margin-right: 6px; }`;

const BottomText = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #e89b3c;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
`;

interface AuthFormProps {
  onAuthSuccess: () => void;
  onClose: () => void;
  variant?: 'modal' | 'widget';
}

const AuthForm: React.FC<AuthFormProps> = ({ onAuthSuccess, onClose, variant = 'widget' }) => {
  const { signIn, signUp, loading, error } = useAuth();
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState('');
  const navigate = useNavigate();

const location = useLocation();

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setFormError('');
  setFormSuccess('');

  try {
    if (isSignUp) {
      await signUp(email, password, name);
      setFormSuccess('Account created successfully!');
    } else {
      await signIn(email, password);
      setFormSuccess('Welcome back!');
    }

    setTimeout(() => {
      onAuthSuccess();

      // ✅ Only redirect if not already on home
      if (location.pathname == '/') {
        navigate('/dashboard');
      }

      

    }, 1000);
  } catch (err: any) {
    const msg =
      err.response?.data?.message ||
      err.message ||
      'Authentication failed. Please try again.';
    setFormError(msg);
  }
};


  return (
    <AuthContainer variant={variant}>
      {variant === 'modal' ? (
        <AuthHeader variant={variant}>
          <HeaderText>
            {process.env.REACT_APP_WIDGET_TITLE || 'K9 Coach AI'}
            <HeaderSubtitle>Your personal Dog expert</HeaderSubtitle>
          </HeaderText>
          <CloseButton onClick={onClose}><FiX /></CloseButton>
        </AuthHeader>
      ) : (
        <CloseButtonFloating onClick={onClose}><FiX /></CloseButtonFloating>
      )}

      <AuthContent variant={variant}>
        <AuthTitle variant={variant}>{isSignUp ? 'Create Account' : 'Welcome Back'}</AuthTitle>
        <AuthSubtitle variant={variant}>
          {isSignUp ? 'Sign up to start your dog  training journey' : 'Sign in to continue your dog  training journey'}
        </AuthSubtitle>

        <ModeToggle>
          <ModeButton active={isSignUp} onClick={() => setIsSignUp(true)}>Sign Up</ModeButton>
          <ModeButton active={!isSignUp} onClick={() => setIsSignUp(false)}>Sign In</ModeButton>
        </ModeToggle>

        <Form onSubmit={handleSubmit}>
          {(formError || error) && <ErrorMessage>{formError || error}</ErrorMessage>}
          {formSuccess && <SuccessMessage>{formSuccess}</SuccessMessage>}

          {isSignUp && (
            <InputGroup>
              <InputWrapper>
                <InputIcon><FiUser size={16} /></InputIcon>
                <Input
                  type="text"
                  placeholder="Your Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled={loading}
                  required
                />
              </InputWrapper>
            </InputGroup>
          )}

          <InputGroup>
            <InputWrapper>
              <InputIcon><FiMail size={16} /></InputIcon>
              <Input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                required
              />
            </InputWrapper>
          </InputGroup>

          <InputGroup>
            <InputWrapper>
              <InputIcon><FiLock size={16} /></InputIcon>
              <Input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                required
              />
              <PasswordToggle type="button" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
              </PasswordToggle>
            </InputWrapper>
          </InputGroup>

          <Button type="submit" disabled={loading}>
            {loading ? (
              <>
                <LoadingSpinner />
                {isSignUp ? 'Creating Account...' : 'Signing In...'}
              </>
            ) : (
              isSignUp ? 'Create Account' : 'Sign In'
            )}
          </Button>
        </Form>

        <BottomText>
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}
          <ToggleButton type="button" onClick={() => setIsSignUp(!isSignUp)}>
            {isSignUp ? 'Sign In' : 'Sign Up'}
          </ToggleButton>
        </BottomText>
      </AuthContent>
    </AuthContainer>
  );
};

export default AuthForm;
